import type { SxProps, Theme } from '@mui/material';

export const reactDateTimeSx: SxProps<Theme> = theme => ({
  '& .rdt': {
    position: 'relative',
  },
  '& .rdt .form-group.form-control': {
    margin: 0,
  },
  '& .rdtPicker': {
    display: 'none',
    position: 'absolute',
    left: 0,
    right: 'auto',
    width: '286px',
    padding: '10px 12px 12px',
    marginTop: '5px',
    zIndex: '99999 !important',
    backgroundColor: 'background.primary',
    boxShadow: 'none',
    border: 0,
    borderRadius: '4px',
  },
  '& .rdtPicker table': {
    width: '100%',
    margin: 0,
    borderSpacing: '3px',
    borderCollapse: 'separate',
  },
  '& .rdtOpen .rdtPicker': {
    display: 'block',
  },
  '& .rdtStatic .rdtPicker': {
    position: 'static',
    boxShadow: 'none',
  },
  '& .rdtPicker .rdtTimeToggle': {
    textAlign: 'center',
    borderRadius: '4px',
  },
  '& .rdtPicker td, & .rdtPicker th': {
    width: '34px',
    height: '32px',
    padding: 0,
    border: 0,
    textAlign: 'center',
  },
  '& .rdtPicker td': {
    cursor: 'pointer',
  },
  '& .rdtPicker td.rdtDay': {
    boxSizing: 'border-box',
    fontSize: '12px',
    lineHeight: '16px',
    color: 'text.primary',
    borderRadius: '4px',
  },
  '& .rdtPicker td.rdtDay:hover, & .rdtPicker td.rdtHour:hover, & .rdtPicker td.rdtMinute:hover, & .rdtPicker td.rdtSecond:hover, & .rdtPicker .rdtTimeToggle:hover':
    {
      backgroundColor: 'background.default',
      cursor: 'pointer',
    },
  '& .rdtPicker td span.rdtOld, & .rdtPicker td.rdtOld, & .rdtPicker td.rdtNew': {
    color: 'text.secondary',
  },
  '& .rdtPicker td.rdtToday': {
    color: 'primary.main',
    backgroundColor: 'transparent',
    boxShadow: `inset 0 0 0 1px ${theme.palette.primary.main}`,
  },
  '& .rdtPicker td.rdtToday:focus, & .rdtPicker td.rdtToday:hover': {
    backgroundColor: 'background.primary',
  },
  '& .rdtPicker td.rdtActive, & .rdtPicker td.rdtActive:hover': {
    backgroundColor: 'primary.main',
    color: 'common.white',
  },
  '& .rdtPicker td.rdtDisabled, & .rdtPicker td.rdtDisabled:hover, & .rdtPicker td span.rdtDisabled, & .rdtPicker td span.rdtDisabled:hover':
    {
      background: 'none',
      opacity: theme.palette.action.disabledOpacity,
      color: 'text.primary',
      cursor: 'not-allowed',
    },
  '& .rdtPicker .dow': {
    height: '45px',
    paddingTop: '10px',
    fontSize: '12px',
    fontWeight: 600,
  },
  '& .rdtPicker th.rdtSwitch': {
    width: '82px',
    fontSize: '14px',
    fontWeight: 600,
  },
  '& .rdtPicker th.rdtNext, & .rdtPicker th.rdtPrev': {
    width: '34px',
    fontSize: '30px',
    fontWeight: 400,
    lineHeight: '34px',
  },
  '& .rdtPrev span, & .rdtNext span': {
    display: 'block',
    WebkitTouchCallout: 'none',
    userSelect: 'none',
    transform: 'translateY(-3px)',
  },
  '& .rdtPicker th.rdtDisabled, & .rdtPicker th.rdtDisabled:hover': {
    background: 'none',
    opacity: theme.palette.action.disabledOpacity,
    color: 'text.primary',
    cursor: 'not-allowed',
  },
  '& .rdtPicker thead tr:first-of-type th': {
    cursor: 'pointer',
    borderRadius: '4px',
  },
  '& .rdtPicker thead tr:first-of-type th:hover': {
    backgroundColor: 'background.default',
  },
  '& .rdtPicker tfoot': {
    transform: 'translateY(12px)',
  },
  '& .rdtPicker button': {
    border: 0,
    background: 'none',
    cursor: 'pointer',
  },
  '& .rdtPicker button:hover': {
    backgroundColor: 'background.default',
  },
  '& .rdtPicker thead button': {
    width: '100%',
    height: '100%',
  },
  '& td.rdtMonth, & td.rdtYear': {
    width: '25%',
    height: '34px',
    cursor: 'pointer',
    borderRadius: '4px',
  },
  '& td.rdtMonth:hover, & td.rdtYear:hover': {
    backgroundColor: 'background.default',
  },
  '& .rdtCounters': {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '7px',
    paddingBottom: '2px',
  },
  '& .rdtCounter': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '44px',
    height: '120px',
    padding: '0 5px',
  },
  '& .rdtCounterSeparator': {
    width: '8px',
    fontSize: '18px',
    lineHeight: '120px',
  },
  '& .rdtCounter .rdtBtn': {
    position: 'relative',
    display: 'block',
    height: '32px',
    fontSize: 0,
    lineHeight: '32px',
    cursor: 'pointer',
    borderRadius: '4px',
    WebkitTouchCallout: 'none',
    userSelect: 'none',
  },
  '& .rdtCounter .rdtBtn::before': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    display: 'block',
    width: '9px',
    height: '9px',
    border: '2px solid',
    borderColor: 'text.primary',
    borderTop: 0,
    borderRight: 0,
    transform: 'translate(-50%, calc(-50% - 2px)) rotate(-45deg)',
    transformOrigin: 'center',
  },
  '& .rdtCounter .rdtBtn:first-of-type::before': {
    transform: 'translate(-50%, calc(-50% + 2px)) rotate(135deg)',
  },
  '& .rdtCounter .rdtBtn:hover': {
    backgroundColor: 'background.default',
  },
  '& .rdtCounter .rdtCount': {
    fontSize: '18px',
  },
  '& .rdtMilli': {
    width: '48px',
    paddingLeft: '8px',
    verticalAlign: 'middle',
  },
  '& .rdtMilli input': {
    width: '100%',
    marginTop: '37px',
    fontSize: '18px',
  },
  '& .rdtTime td': {
    cursor: 'default',
  },
  '& .rdtPicker .rdtTimezone': {
    display: 'block',
    marginTop: '16px',
    marginBottom: '10px',
    fontSize: '14px',
    lineHeight: 1,
    textAlign: 'center',
  },
  '& .rdtPicker .rdtTodayBtn': {
    display: 'block',
    margin: '16px 6px 5px',
    padding: '4px 15px',
    color: 'primary.main',
    fontSize: '14px',
  },
  '& .rdtPicker .rdtTodayBtn:hover': {
    backgroundColor: 'transparent',
    textDecoration: 'underline',
  },
  '& .datetime-container.open-top .rdtPicker': {
    top: 'auto !important',
    bottom: '100% !important',
    marginBottom: '4px',
  },
  '& .datetime-container.open-left .rdtPicker': {
    right: '0 !important',
    left: 'auto !important',
  },
  [theme.breakpoints.down('sm')]: {
    '& .rdtPicker': {
      width: '250px',
      padding: '5px 8px 8px',
      fontSize: '14px',
    },
    '& .rdtPicker td, & .rdtPicker th': {
      height: '30px',
    },
    '& .rdtPicker .dow': {
      height: '32px',
      paddingTop: '10px',
    },
    '& .rdtPicker .rdtTimezone': {
      fontSize: '12px',
    },
    '& .rdtPicker th.rdtNext, & .rdtPicker th.rdtPrev': {
      width: '30px',
      lineHeight: '30px',
    },
    '& .rdtCounter': {
      width: '50px',
      padding: '0 10px',
    },
    '& .rdtCounter .rdtBtn': {
      height: '30px',
      lineHeight: '30px',
    },
    '& .rdtCounter .rdtBtn::before': {
      width: '30px',
      lineHeight: '30px',
    },
  },
});
